import { useEffect } from 'react'

import FormGroup from '../../../components/ReusableComponents/ManageHotel/FormGroup/index'
import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import useFirstRender from '../../../hooks/useFirstRender'
import { privacyURLs, termsURLs } from '../../../main/hotelBrandsAndChains'
import styles from './Legal.module.scss'

const Legal = ({
  formData: { termsUrl, privacyUrl },
  setFormData,
  handleValidated,
  valid,
  parentChainCode
}) => {
  const handleUrlChange = e => {
    let { value } = e.target
    if (value && value.length > 8 && !value.match(/^https:\/\//)) {
      value = `https://${value}`
    }

    setFormData({
      [e.target.name]: value
    })
  }

  useFirstRender(() => {
    const savedPrivacyUrl = privacyURLs[parentChainCode]
    const savedTermsUrl = termsURLs[parentChainCode]

    if (savedPrivacyUrl && !privacyUrl) {
      setFormData({ privacyUrl: savedPrivacyUrl })
    }
    if (savedTermsUrl && !termsUrl) {
      setFormData({ termsUrl: savedTermsUrl })
    }
  })

  useEffect(() => {
    const isValid = termsUrl && termsUrl.length > 8 && privacyUrl && privacyUrl.length > 8

    handleValidated(!!isValid)
  }, [handleValidated, privacyUrl, termsUrl])

  return (
    <FormGroup title="Legal (optional)" done={valid}>
      <TextInput
        label="Terms URL"
        className={styles.input}
        value={termsUrl}
        name="termsUrl"
        type="search"
        onChange={handleUrlChange}
        valid={termsUrl && termsUrl.length > 8}
      />
      <TextInput
        label="Privacy URL"
        className={styles.input}
        value={privacyUrl}
        name="privacyUrl"
        type="search"
        onChange={handleUrlChange}
        valid={privacyUrl && privacyUrl.length > 8}
      />
    </FormGroup>
  )
}

export default Legal
